class MegaMenuPanels extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()
    this.listeners.add(
      this.els.trigger.element,
      'keydown',
      this.onTriggerClick.bind(this),
    )

    this.listeners.add(this, 'keydown', this.onEscape.bind(this))

    this.listeners.add(
      document.querySelector('.hd-Banner_Nav'),
      'mouseenter',
      this.increaseSiteHeaderZIndex.bind(this),
    )

    this.listeners.add(
      document.querySelector('.hd-Banner_Nav'),
      'mouseleave',
      this.decreaseSiteHeaderZIndex.bind(this),
    )

    this.externalEls.trigger.elements.forEach(trigger =>
      this.listeners.add(
        trigger,
        'keydown',
        this.arrowKeyboardNavigation.bind(this),
      ),
    )

    this.listeners.add(this, 'focusout', this.onFocusOut.bind(this))
  }

  onTriggerClick (e) {
    if (e.key === 'Enter' || e.key === 'ArrowDown' || e.key === ' ') {
      e.preventDefault()

      if (this.els.panel.element.getAttribute('aria-hidden') === 'true') {
        this.openPanel(this.els.panel.element)
        e.target.setAttribute('aria-expanded', true)
      } else {
        this.closePanel(this.els.panel.element)
        e.target.setAttribute('aria-expanded', false)
      }
    }
  }

  onEscape (e) {
    if (e.key !== 'Escape') return
    this.closePanel(this.els.panel.element)
    this.els.trigger.element.focus()
  }

  closePanel (el) {
    el.setAttribute('aria-hidden', true)
  }

  openPanel (el) {
    el.setAttribute('aria-hidden', false)
  }

  increaseSiteHeaderZIndex () {
    if (window.matchMedia('(min-width: 768px)').matches) {
      document.querySelector('#shopify-section-header').style.zIndex = '20'
    }
  }

  decreaseSiteHeaderZIndex () {
    if (window.matchMedia('(min-width: 768px)').matches) {
      document.querySelector('#shopify-section-header').style.zIndex = '10'

      this.closePanel(this.els.panel.element)
    }
  }

  onFocusOut (e) {
    if (this.contains(e.relatedTarget)) return
    this.closePanel(this.els.panel.element)
    this.els.trigger.element.setAttribute('aria-expanded', false)
  }

  arrowKeyboardNavigation (e) {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      this.externalEls.trigger.elements.forEach(trigger => {
        if (e.target !== trigger) {
          trigger.focus()
        }
      })
    }
  }

  connectedCallback () {
    this.setupListeners()
  }
}

if (!customElements.get('mega-menu-panels')) {
  customElements.define('mega-menu-panels', MegaMenuPanels)
}
